import React, { Fragment, Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as assessmentsActions from '../../redux/actions/assessmentsActions';
import * as sectionsActions from '../../redux/actions/sectionsActions';

import IntroPagination from '../features/assessment/IntroPagination';

class NewAssessmentIntroPage extends Component {
  constructor(props) {
    super(props);
    this.state = { nameError: false };
  }

  componentDidMount() {
    if (!this.props.status.sections) {
      this.props.sectionsActions.getSections();
    }
    if (!this.props.assessments[this.props.match.params.assessmentId]) {
      // grab the assessment from the database if necessary
      this.props.assessmentsActions.getAssessment(this.props.match.params.assessmentId, true);
    } else if (this.props.currentAssessment.id !== this.props.match.params.assessmentId) {
      // no need for more from the database, just update the current assessment
      this.props.assessmentsActions.updateCurrentAssessment(this.props.assessments[this.props.match.params.assessmentId]);
    }
  }

  render() {
    const { history, sections, currentAssessment } = this.props;

    // Jump out if it's a corrupted assessment
    if (!this.props.currentAssessment.section) return <Redirect to="/assessments/new" />;
    const section = sections[currentAssessment.section];
    // Wait for section to load
    if (!section) return null;
    // If this section doesn't have an intro, jump back to the preface
    if (!section.hasIntro) return <Redirect to={`/assessments/${currentAssessment.id}/preface`} />;

    return (
      <Fragment>
        <Helmet>
          <title>New Assessment</title>
        </Helmet>
        <div className="new-assessment-detail">
          <div className="row">
            <div className={'new-assessment-detail__heading color--' + section.theme}>
              {section.fullTitle}
            </div>
          </div>
          <div className="row">
            <div className="new-assessment-detail__text">
              {section.introText.split('\n\n').map((pText, i) => (
                <p key={i}>
                  {pText}
                </p>
              ))}
            </div>
          </div>
          <IntroPagination
            putAssessment={() => undefined} // don't bother to PUT from this page
            navigate={history.push}
          />
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
    assessments: state.assessments.list,
    currentAssessment: state.assessments.currentAssessment,
    status: state.status,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assessmentsActions: bindActionCreators(assessmentsActions, dispatch),
    sectionsActions: bindActionCreators(sectionsActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NewAssessmentIntroPage);



// WEBPACK FOOTER //
// ./src/components/pages/NewAssessmentIntroPage.js